(function (context) {

    /**
     * @param {string} url
     * @return {Promise<void>}
     */
    function getSvgDocument(url) {
        return new Promise(async function(resolve, reject) {
            const response = await fetch(url);
            if (response.ok) {
                const text = await response.text();
                const svgDocument = new DOMParser().parseFromString(text, "image/svg+xml");
                resolve(svgDocument);
            } else {
                reject(new Error(`response status for ${url} not ok`));
            }
        });
    }

    /**
     * @param {HTMLElement|SVGElement} fromNode
     * @param {HTMLElement|SVGElement} toNode
     */
    function copyClassNames(fromNode, toNode) {
        fromNode.classList.forEach(className => {
            toNode.classList.add(className);
        });
    }

    /**
     * @param {SVGElement} symbol
     * @return {Promise}
     */
    function replaceSymbol(symbol) {
        symbol.classList.remove('replace-symbol');
        return new Promise((resolve, reject) => {
            const useElement = symbol.children[0] ?? null;
            if (!(useElement instanceof Element) || useElement.tagName.toUpperCase() !== "USE") {
                return reject(new Error('can not find use element inside svg node with replace-symbol class'));
            }
            const fullUrl = symbol.childNodes[0].getAttribute('href');
            const fragmentPosition = fullUrl.indexOf('#');
            const url = fragmentPosition > -1 ? fullUrl.substr(0, fragmentPosition) : fullUrl;
            getSvgDocument(url).then(svgDocument => {
                const svg = svgDocument.documentElement;
                svg.removeAttribute('id');
                copyClassNames(symbol, svg);
                svg.classList.add('symbol-replaced');
                if (symbol.hasAttribute('width')) {
                    svg.setAttribute('width', symbol.getAttribute('width'));
                }
                if (symbol.hasAttribute('height')) {
                    svg.setAttribute('height', symbol.getAttribute('height'));
                }
                symbol.replaceWith(svg);
                resolve();
            }).catch(reject);
        });
    }

    /**
     * @param {HTMLImageElement} img
     * @return {Promise}
     */
    function replaceImage(img) {
        img.classList.remove('replace-with-svg');
        return new Promise((resolve, reject) => {
            getSvgDocument(img.src).then(svgDocument => {
                const svg = svgDocument.documentElement;
                copyClassNames(img, svg);
                svg.classList.add('image-replaced');
                img.replaceWith(svg);
                resolve();
            }).catch(reject);
        });
    }

    function process() {
        Promise.all([].concat(
            Array.from(context.querySelectorAll('svg.replace-symbol')).map(replaceSymbol),
            Array.from(context.querySelectorAll('img.replace-with-svg')).map(replaceImage),
        )).then(() => void(0));
    }

    process();
    const observer = new MutationObserver(process);
    observer.observe(context, {
        childList: true,
        subtree: true,
    });
})(document);
